import { createMutationHook } from '~/shared/providers/api';

export const useGenFileDownloadUrl = createMutationHook(
  'customerPortal.generateFileDownloadUrl',
  ({ fileIds }: { fileIds: string[] }) => ({
    filesGenerateFileAccessURL: {
      __args: {
        fileIds,
      },
      results: {
        fileId: true,
        url: true,
      },
    },
  }),
  {
    select: (data) =>
      data.filesGenerateFileAccessURL.results.map((result) => ({
        fileId: result.fileId,
        url: result.url,
      })),
  },
);
